// @flow

import ARGENTINA from '@tectonics/commons/country/countries/argentina';
import BOLIVIA from '@tectonics/commons/country/countries/bolivia';
import BRAZIL from '@tectonics/commons/country/countries/brazil';
import CHILE from '@tectonics/commons/country/countries/chile';
import COLOMBIA from '@tectonics/commons/country/countries/colombia';
import ECUADOR from '@tectonics/commons/country/countries/ecuador';
import MEXICO from '@tectonics/commons/country/countries/mexico';
import PERU from '@tectonics/commons/country/countries/peru';
import URUGUAY from '@tectonics/commons/country/countries/uruguay';
import PARAGUAY from '@tectonics/commons/country/countries/paraguay';
import COSTA_RICA from '@tectonics/commons/country/countries/costa_rica';
import PANAMA from '@tectonics/commons/country/countries/panama';
import GUATEMALA from '@tectonics/commons/country/countries/guatemala';
import EL_SALVADOR from '@tectonics/commons/country/countries/el_salvador';
import DOMINICAN_REPUBLIC from '@tectonics/commons/country/countries/dominican_republic';
import SOUTH_AFRICA from '@tectonics/commons/country/countries/south_africa';
import KENYA from '@tectonics/commons/country/countries/kenya';
import NIGERIA from '@tectonics/commons/country/countries/nigeria';
import INDIA from '@tectonics/commons/country/countries/india';
import PHILIPPINES from '@tectonics/commons/country/countries/philippines';
import TANZANIA from '@tectonics/commons/country/countries/tanzania';
import UGANDA from '@tectonics/commons/country/countries/uganda';
import ZAMBIA from '@tectonics/commons/country/countries/zambia';
import EGYPT from '@tectonics/commons/country/countries/egypt';
import GHANA from '@tectonics/commons/country/countries/ghana';
import INDONESIA from '@tectonics/commons/country/countries/indonesia';
import JAMAICA from '@tectonics/commons/country/countries/jamaica';
import THAILAND from '@tectonics/commons/country/countries/thailand';
import TURKEY from '@tectonics/commons/country/countries/turkey';
import type { PaymentMethod } from '@tectonics/commons/new-payment-methods/payment-method';
import type { Country as CountryCode } from '@tectonics/prs/country';
import type { CustomerForm } from '@tectonics/commons/customer-form/types';
import type { OutgoingPayment } from '@tectonics/prs/outgoing-payment';

export type TaxDisplayConfig = {|
  taxCode: string,
  percentage: string,
  label: string,
  tooltipLabel: string,
  tooltipTextKey: string,
  testId: string,
|};

export type Country = {
  code: CountryCode,
  supportedPaymentMethods?: Array<PaymentMethod>,
  outgoingPaymentMapper?: () => $Shape<OutgoingPayment>,
  customerForm: CustomerForm,
  taxDisplay?: TaxDisplayConfig,
};

export const SUPPORTED_COUNTRIES: Array<Country> = [
  ARGENTINA,
  BOLIVIA,
  BRAZIL,
  CHILE,
  COLOMBIA,
  ECUADOR,
  MEXICO,
  PERU,
  URUGUAY,
  PARAGUAY,
  COSTA_RICA,
  PANAMA,
  GUATEMALA,
  EL_SALVADOR,
  DOMINICAN_REPUBLIC,
  SOUTH_AFRICA,
  KENYA,
  NIGERIA,
  INDIA,
  PHILIPPINES,
  TANZANIA,
  UGANDA,
  ZAMBIA,
  EGYPT,
  GHANA,
  INDONESIA,
  JAMAICA,
  THAILAND,
  TURKEY,
];

export function getCountryFromCode(countryCode: string): ?Country {
  return SUPPORTED_COUNTRIES.find((country: Country) => {
    return country.code === countryCode;
  });
}

export function getSafeCountryFromCode(countryCode: string): Country {
  const country = SUPPORTED_COUNTRIES.find((country: Country) => {
    return country.code === countryCode;
  });

  if (!country) {
    throw new Error(`Unsupported country "${countryCode}"`);
  }

  return country;
}
